module.exports = __webpack_public_path__ + "img/headshot-2.3fe0f1a4.png";